import StatusChip from "@entrilia/shared/components/StatusChip";
import type { InvestorPortalRoleWithNoneValue } from "../../api/types/investorContactsTypes";

interface Props {
  role: InvestorPortalRoleWithNoneValue;
}

const PortalRoleChip = ({ role }: Props) => {
  switch (role) {
    case "Admin":
      return <StatusChip label="Admin" color={(t) => t.palette.info.main} />;
    case "Member":
      return <StatusChip label="Member" color={(t) => t.palette.success.main} />;
    case "None":
    default:
      return <StatusChip label="None" color={(t) => t.palette.text.secondary} neutral />;
  }
};

export default PortalRoleChip;
